export type Language = 'nl' | 'en' | 'de' | 'fr' | 'es'

export type LanguageOption = {
  code: Language
  label: string
  short: string
  flag: string
}

export const languageOptions: LanguageOption[] = [
  { code: 'nl', label: 'Nederlands', short: 'NL', flag: '🇳🇱' },
  { code: 'en', label: 'English', short: 'EN', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', short: 'DE', flag: '🇩🇪' },
  { code: 'fr', label: 'Français', short: 'FR', flag: '🇫🇷' },
  { code: 'es', label: 'Español', short: 'ES', flag: '🇪🇸' },
]
